import { useContext, useMemo } from 'react'

import { EmptyArray } from 'lib/array/arrayUtils'
import ExploreQueryContext from 'tripPlanner/contexts/Explore/ExploreQueryContext'
import { useExploreItems } from 'tripPlanner/hooks/api/explore'
import type { ExploreItem } from 'tripPlanner/types/common'
import useHeldValue from 'hooks/useHeldValue'
import { mapToExploreMarker } from '../utils'
import type { TripTab } from 'tripPlanner/utils/tabs'

export default function useExplorePins(tab: TripTab) {
  const {
    query: exploreQuery,
    locationBias,
    category: initialCategory,
  } = useContext(ExploreQueryContext)

  const {
    isLoading: exploreIsLoading,
    data: initialExploreItems = EmptyArray as Array<ExploreItem>,
  } = useExploreItems({
    query: exploreQuery,
    locationBias,
  })

  const exploreCategory = useHeldValue(initialCategory, exploreIsLoading)

  const exploreItems = useHeldValue(initialExploreItems, exploreIsLoading)

  const exploreItemsToUse: Array<ExploreItem> = tab === 'Explore' ? exploreItems : EmptyArray

  const exploreMarkers = useMemo(() => {
    return exploreItemsToUse.map(mapToExploreMarker)
  }, [exploreItemsToUse])

  return {
    exploreItems,
    exploreCategory,
    exploreMarkers,
    exploreIsLoading,
  }
}
